export const GET_TEAM_SALES = `
  query GetAllTeamSale($input: TteamSalesWhereInput, $skip: Float, $take: Float) {
    getTeamSales(where: $input, skip: $skip, take: $take,orderBy:{createDate: DESC}) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        subId
        name
        isWork
        plantId
        salesTeamCode
        teamType
        createDate
        tteamSalesRoute{
          id
          teamSalesId
          routeId
          troute{
              id
              name
          }
        }
        tcreateUser {
          id
          fullName
        }
        modifyDate
        tmodifyUser{
          id
          fullName
        }
        useYn
        teamCapacity
        sloc
        endDate
        plantId
        statusId
        tstatus{
          id
          name
        }
        tplant {
          id
          name
          companyId
        }
        tteamType {
          id
          name
          note
        }
        tteamSalesDetails{
        id
        sloc
        startDate
        endDate
        userId
        user{
          id
          fullName
          avatar
          email
          phoneNumber
        }
        useYn
        leaderYn
        }
      }
    }
  }
`;

export const Q_CREATE_TEAMSALE = `
  mutation CreateTeamSale($data: TteamSalesInput!) {
    createTeamSales(input: $data) {
      id
      name
      isWork
      plantId
      salesTeamCode
      teamType
      teamCapacity
      endDate
      sloc
    }
  }
`;

export const Q_CREATE_LIST_TEAM_SALE = `
mutation CreateTeamSaleCust($data: [TteamSalesCustInput!]!) {
  createManyTeamSalesCust(input: $data) {
    id
    custId
    teamSalesId
    indexNum
    createId
    createDate
  }
}`;

export const Q_UPDATE_TEAMSALE = `
  mutation UpdateTeamSale($data: TteamSalesInput!) {
    updateTeamSales(input: $data) {
      id
      name
      isWork
      useYn
      plantId
      salesTeamCode
      teamType
      teamCapacity
      endDate
      modifyDate
    }
  }
`;

export const Q_DELETE_TEAMSALE = `mutation DeleteTeamSale($input: String!){
    deleteTeamSales(id: $input){
        code
        message
        success
    }
}`;

export const Q_DELETE_EMPLOYEE_TEAM_SALE = `
  mutation DeleteTeamSaleDetail($data: String!) {
    deleteTeamSalesDetail(id:$data){
      success
      code
      message
    }
  }
`;

export const Q_GET_EMPLOYEES_NO_TS = `query GetUser($input: TuserWhereInput, $skip: Float, $take: Float) {
  getUser(where: $input, skip: $skip, take: $take) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      email
      fullName
      avatar
      phoneNumber
      isWorking
      role
      activeRoute
    }
  }
}
`;

export const Q_ADD_EMPLOYEE_TS = `
  mutation CreateTeamSaleDetail($data: TteamSalesDetailInput!) {
    createTeamSalesDetail(input: $data) {
      id
      sloc
      userId
      useYn
      teamSaleId
      leaderYn
      startDate
      endDate
    }
  }
`;

export const CREATE_MANY_EMPLOYEE_TS = `
  mutation CreateMany($input: [TteamSalesDetailInput!]!){
    createManyTeamSalesDetail(input: $input){
      teamSaleId
      userId
      sloc
    }
  }
`;

export const Q_GET_TS_BY_ID = `
  query GetTeamSaleDetailById(
  $input: TteamSalesDetailWhereInput
  $skip: Float
  $take: Float
  ) {
    getTeamSalesDetail(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        sloc
        startDate
        createDate
        modifyDate
        endDate
        user {
          id
          fullName
          departmentName
          departmentCode
          avatar
          active
          division
          email
          employeeId
          documents
          phoneNumber
          role
          jobTitle
          jobTitleCode
          plantCode
          permissionGroup
          groupLogin
        }
        tteamSales {
          id
          name
          isWork
          plantId
          salesTeamCode
          tteamType {
            id
            name
            note
            status
            createDate
          }
          trevenuePlanTteamsales {
            id
            novSaleamt
            approval {
              id
              fullName
              avatar
              departmentCode
              departmentName
              division
              divisionCode
              documents
              email
              employeeId
              managerEmail
              isWorking
              phoneNumber
              jobTitle
              jobTitleCode
              latitude
              longitude
              role
            }
            approvalDate
            aprProfitSaleamt
          }
          tsalesPlannings {
            id
            name
            plantId
            expectedRevenue
            implementationDate
            saleEndDate
            saleStartedDate
            teamSales {
              id
              name
              isWork
              plantId
              salesTeamCode
              createDate
              useYn
            }
            createDate
            approvalDate
          }
        }
        useYn
        leaderYn
      }
    }
  }
`;

export const Q_GET_CUSTOMER_BY_TS = `
  query GetAllTeamSaleCust(
    $input: TteamSalesCustWhereInput
    $skip: Float
    $take: Float
  ) {
    getTeamSalesCust(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}){
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items{
          id
          custId
          teamSalesId
          indexNum
          createDate
          useYn
          tcustomer{
              id
              storeName
              address
              phone
              cccd
              sapCustomerId
              taxId
              rankId
              trank{
                  id
                  name
              }
              trankProcess{
                  name
              }
              trankProduct{
                  name
              }
              tcity{
                  id
                  name
              }
              tdistrict{
                  id
                  name
              }
              tward{
                  id
                  name
              }
          }
          tteamSale{
              id
              name
          }
      }
    }
  }
`;

export const Q_DELETE_TEAM_SALE_CUST = `
mutation DeleteTeamSalesCust($input: String!){
  deleteTeamSalesCust(id: $input){
      code
      message
      success
  }
}
`;

export const Get_Customer_By_Team_Sale_Route = `
  query GetCustomerByTeamSaleRoute($input:VCustTeamRouteViewWhereInput,$skip:Float,$take:Float){
    getCustTeamRouteView(where:$input,skip:$skip,take:$take){
      pageInfo{
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items{
        id
        expectedRevenue
        sapCustomerId
        teamSaleId
        longitude
        storeName
        latitude
        districtName
        cityName
        wardName
        districtName
        routeId
        rankName
        teamSaleId
        syncStatus
        rankProcess
        rankProduct
        cccd
        t2
        t3
        t4
        t5
        t6
        t7
        cn
        week1
        week2
        week3
        week4
        taxId
      }
    }
  }
`;

export const GET_TEAM_SALES_COMBOBOX = `
  query GetAllTeamSale($input: TteamSalesWhereInput, $skip: Float, $take: Float) {
    getTeamSales(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        subId
        name
        isWork
        plantId
        useYn
        createDate
        modifyDate
      }
    }
  }
`;

export const GET_TEAM_SALES_COMBOBOX_SUB_SORT = `
  query GetAllTeamSale($input: TteamSalesWhereInput, $skip: Float, $take: Float) {
    getTeamSales(where: $input, skip: $skip, take: $take, orderBy:[{subId: ASC},{name: ASC},{createDate: ASC}]) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        subId
        name
        isWork
        plantId
        useYn
        createDate
        modifyDate
      }
    }
  }
`;

export const ADD_CUSTOMER_IN_TEAM_ROLE = `
mutation AddCustomerInTeamRoute($input: TeamOrRouteInput!){
    createCustinTeamOrRoute(input: $input){
        code
        success
        message
    }
}
`;

export const UPDATE_MANY_TEAM_SALE_DETAIL = `
  mutation CreateMany($input: [TteamSalesDetailInput!]!){
    updateManyTeamSalesDetail(input: $input){
      teamSaleId
      userId
      sloc
      useYn
      
    }
  }
`;

export const GENERATE_TEAM_CODE = `
  query GenarateId($input: GenarateIdInput){
    genarareId(input: $input){
      id
      subId
    }
  }
`;

export const GET_USER_BY_PLANT_ID = `
  query GetUserByPlant($input: TuserWhereInput!, $skip: Float, $take: Float ){
    getUser(where: $input,skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            email
            fullName
            phoneNumber
            role
            plantCode
            division
            permissionGroup
            jobTitle
            jobTitleCode
            departmentCode
            departmentName
            email
            sloc
            isWorking
            activeRoute
        }
    }
  }
`;

export const GET_SLOC_BY_PLANT_ID = `
  query GetSlocByTeamSale($input: TslocWhereInput, $skip: Float, $take: Float){
    getSloc(where:$input, skip: $skip,take: $take,){
      pageInfo{
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items{
        id
        plantId
      }
    }
  }
`;

export const GET_PROGRESS_BY_PLANT_ID = `
  query GetProgressRevenuePlanTeamSale(
    $input: ProgressRevenuePlantInput!
  ) {
    getProgressRevenuePlant(where: $input) {
      plantId
      tteamSalesId
      yr
      progressRevenuePlant{
          mon
          sumFinalPrice
          percentPrice
      }
    }
  }
`;

export const GET_ALL_TOTAL_SALE_AMT = `
  query GetAllTotalSaleAmt($input:FGetAllTotalYearSaleAmtInput!){
      getFAllTotalYearSaleAmt(where:$input){
          plantId
          totalYearSaleamtAll
          year
      }
  }
`;

export const GET_ALL_FITLER_TEAM_SALES = `
  query GetAllTeamSale($input: TeamSalesListInput, $skip: Float, $take: Float) {
    getTeamSalesList(where: $input, skip: $skip, take: $take){
      pageInfo{
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        subId
        name
        plantId
        sloc
        useYn
        companyId
        companyName
        teamCapacity
        teamTypeName
        statusName
        teamUserName
        userLeader
        userIds
        createDate
        modifyDate
        createName
        modifyName
        manageId
        manageName
        manageEmail
      }
    }
  }
`;

export const GET_ALL_TEAM_SALES_DETAIL_BY_ID = `
  query GetTeamSaleDetailById(
  $input: TteamSalesDetailWhereInput
  $skip: Float
  $take: Float
  ) {
    getTeamSalesDetail(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        sloc
        user{
          id
          fullName
        }
        useYn
        leaderYn
      }
    }
  }
`;

export const CHECK_EXIST_ROUTE_OF_SALE_TEAM = `
  query CheckExistedTeamsaleRoute($input:TteamSalesRouteWhereInput!){
    getTeamSalesRoute(where:$input){
      items{
        id
        troute{
          id
          name
        }
        teamSalesId
      }
    }
  }
`;

export const CHECK_VALID_SALE_TEAM_BY_ID = `
  query GetValidTeamSale($input: TteamSalesWhereInput, $skip: Float, $take: Float) {
    getTeamSales(where: $input, skip: $skip, take: $take,orderBy:{createDate: DESC, id: ASC}) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        name
        isWork
        useYn
        
      }
    }
  }
`;

export const GET_VALID_TEAM_SALE_BY_ID = `
  query GetValidTeamSale($input: TteamSalesWhereInput, $skip: Float, $take: Float) {
    getTeamSales(where: $input, skip: $skip, take: $take,orderBy:{createDate: DESC, id: ASC}) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        name
        useYn
      }
    }
  }
`;

export const CHECK_USER_ACTIVE_ROUTE_IN_TEAM = `
  query CheckUserActiveRouteInTeam($input:CheckUserActiveRouteInput){
    CheckUserActiveRouteInTeam(where:$input){
      message
      conflictData{
        team
        user
      }
      success
    }
  }
`;

export const GET_MANAGER_COMBOBOX = `
  query GetManagerComboBox($input:TuserWhereInput,$skip:Float,$take:Float){
    getUser(where:$input,skip:$skip,take:$take){
      pageInfo{
        currentPage
        hasNextPage
        itemsPerPage
        hasPreviousPage
        totalItems
        totalPages
      }
      items{
        id
        fullName
        email
        role
        plantCode
      }
    }
  }
`;

export const DELETE_MANY_TEAM_SALE_DETAIL = `
  query DeleteManyTeamSalesDetail($input: DeleteManyInput) {
    deleteTeamManySaleDetail(input: $input){
        status,
        message
    }
  }
`;
